module.exports = __webpack_public_path__ + "img/Atmos Haus der Musik-Kleiner Saal_1.jpg";